/**
 * Financial Aid Layout Component
 *
 * Embedded content-only layout for /school/financialaid routes.
 * Global shell chrome and sidebar are provided by the app-shell.
 */
import { Outlet } from 'react-router-dom';
import styles from './FinancialAidLayout.module.css';

export function FinancialAidLayout() {
  return (
    <div
      className={styles.layout}
      data-testid="financial-aid-layout"
      data-extracted-from="owned:ystnj/financial-aid/layout-embedded-content-only"
    >
      <main
        className={styles.contentArea}
        data-testid="financial-aid-layout-content"
        data-extracted-from="owned:ystnj/financial-aid/layout-embedded-content"
      >
        <Outlet />
      </main>
    </div>
  );
}
